"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Carousel = require("./Carousel.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CarouselImage = function CarouselImage(props) {
  return _react.default.createElement(_Carousel.StyledCarouselImage, null, _react.default.createElement(_Carousel.StyledImage, {
    src: props.imageSrc
  }));
};
/**
 * Definition of default values for component props
 */


exports.CarouselImage = CarouselImage;
CarouselImage.defaultProps = {
  children: undefined,
  imageSrc: undefined
};
CarouselImage.propTypes = {
  /** Content to be rendered in the Carousel */
  children: _propTypes.default.node,
  imageSrc: _propTypes.default.string
};